module.exports = __webpack_public_path__ + "static/media/bullies.0b5a48eb.jpg";